import PageHeader from "@/components/site/PageHeader";
import { INDUSTRIES } from "@/data/site";

const INDUSTRY_BLURBS = {
  "Manufacturing": "Shop-floor systems, MES, planning and IoT-led visibility.",
  "Engineering": "Project delivery platforms, drawings and document control.",
  "Construction": "Site, vendor, procurement and progress management.",
  "Infrastructure": "Asset, contract and lifecycle management at scale.",
  "Oil & Gas": "Field operations, compliance and integration with SCADA.",
  "Logistics": "Fleet, dispatch, last-mile and warehouse intelligence.",
  "Retail": "Commerce, store ops, loyalty and personalisation.",
  "Healthcare": "Clinical workflows, patient experience and compliance.",
  "Education": "Learning platforms, admissions and student lifecycle.",
  "Professional Services": "Practice management, billing and knowledge workflows.",
};

export default function Industries() {
  return (
    <main data-testid="industries-page">
      <PageHeader
        overline="Industries"
        title="Domain depth that compounds over time"
        subtitle="We bring the patterns and reference architectures of the industries we know best — so we can talk strategy, not just stack."
        testid="industries-page-header"
      />

      <section className="py-12 md:py-16">
        <div className="container-zx grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((i) => (
            <div key={i.label} className="card-surface p-7" data-testid={`industry-card-${i.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="h-11 w-11 rounded-lg grid place-items-center bg-cyan/10 border border-cyan/25 text-cyan">
                <i.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-white">{i.label}</h3>
              <p className="mt-2 text-sm text-ink-400 leading-relaxed">{INDUSTRY_BLURBS[i.label]}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
